import React, { useState, useEffect } from "react";

import { ContactForm } from './../../components/contactForm/ContactForm';
import { TileList } from './../../components/tileList/TileList';

export const ContactsPage = ({contacts, addContact}) => {

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [duplicate, setDuplicate] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!duplicate){
      addContact(name, phone, email);
      setName('');
      setPhone('');
      setEmail('');
    }
  };

  useEffect(()=> {
    const duplicateCheck = () => {
      const contactCheck = contacts.find(contact => contact.name === name);
      if( contactCheck !== undefined){
        return true
      } else {
        return false;
      }
    };

    if(duplicateCheck()){
      setDuplicate(true);
    } else {
      setDuplicate(false);
    }
  }, [name, contacts, duplicate])

  return (
    <div>
      <section>
      <div className='card'>
          <div className='card-body'>
          <h2 className='card-title'>
            Add Contact
            {duplicate ? 'This person is already on the database' : ''}
          </h2>
              <ContactForm
                name = {name}
                phone = {phone}
                email = {email}
                setName = {setName}
                setPhone = {setPhone}
                setEmail = {setEmail}
                handleSubmit = {handleSubmit}
              />
          </div>
        </div>
      </section>
      <hr />
      <section>
        <div className='card'>
          <div className='card-body'>
            <h2 className='card-title'>Contacts</h2>
            <TileList
              tiles={contacts}
            />
          </div>
        </div>
      </section>
    </div>
  );
};
